// Throttle simple implementation
// import throttle from '@/helpers/throttle';
// throttle(() => { console.log('my function') }, 1000);

const timers = new Map();

/**
 * Тротл за сигнатурою: однакова сигнатура => спільний "паузовий" стан.
 * @param {Function} callback - те, що потрібно викликати
 * @param {number} wait - інтервал у мс
 * @param {string} [key] - не обов’язково: власний ключ, якщо не хочете покладатися на toString()
 */
export default function throttle(callback, wait = 0, key) {
    const signature = key /*|| (callback && callback.name)*/ || callback.toString();
    //console.log('signature:', callback.name, callback.toString())

    if (timers.has(signature)) return; // вже в паузі — ігноруємо
    timers.set(signature, true);

    setTimeout(() => {
        try {
            callback();
        } finally {
            timers.delete(signature);
        }
    }, wait);
}

/* // Previous local component the throttle implementation
let throttlePause;
const throttle = (callback, time) => {
    if (throttlePause) return;
    throttlePause = true;
    setTimeout(() => {
        callback();
        throttlePause = false;
    }, time);
};*/